import React from 'react';

import styles from './index.module.scss';
import {
  ProfileHeader,
  ProfileForm
} from '../../components/profile/index.troy';

import { sendProfileChanges } from '../../actions';
import { connectTo } from '../../utils';

class Profile extends React.Component {
  onSubmitForm = values => {
    const { sendProfileChanges } = this.props;
    sendProfileChanges(values);
  };

  render() {
    const { firstName, profileInfo } = this.props;
    return (
      <div className={styles['profile__wrapper']}>
        <div className={styles['profile__content']}>
          <ProfileHeader />
          <ProfileForm
            onSubmit={this.onSubmitForm}
            firstName={firstName}
            profile={profileInfo || {}}
          />
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({ profile: profileInfo }) => ({
    profileInfo,
    firstName: profileInfo.firstname
  }),
  { sendProfileChanges },
  Profile
);
